export default "__VITE_ASSET__6a9d395c__"